import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { supabase } from "@/lib/supabase";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Store } from "lucide-react";
import { cn } from "@/lib/utils";
/**
 * Selettore sede per l'utente (i venditori sono agganciati a una sede,
 * il titolare può filtrare fra Selva di Altino, Vasto Marina o Tutte).
 * Salva la scelta in localStorage e la annuncia con l'evento `ida:sede`: il
 * cruscotto la segue (dal 24-09), le altre pagine ancora no. Ascolta lo stesso
 * evento, così se la sede cambia da una pagina anche questo selettore si allinea.
 * `suBlu`: la versione del menu blu (bordo chiaro, testo bianco).
 */
export default function ShowroomSelector({ suBlu = false }) {
  const [sedi, setSedi] = useState([]);
  const [value, setValue] = useState(
    () => localStorage.getItem("ida:sede") || "all",
  );
  useEffect(() => {
    const segui = (e) => setValue(e.detail || "all");
    window.addEventListener("ida:sede", segui);
    return () => window.removeEventListener("ida:sede", segui);
  }, []);
  useEffect(() => {
    // Senza sessione la chiamata tornerebbe 401: non la si fa proprio. Serve
    // anche a tenere muta la pagina di riferimento /design, che monta il guscio
    // vero senza essere loggata e deve restare senza rete.
    let vivo = true;
    supabase.auth.getSession().then(({ data }) => {
      if (!vivo || !data.session) return;
      api
        .get("/sedi")
        .then((r) => vivo && setSedi(r.data || []))
        .catch(() => vivo && setSedi([]));
    });
    return () => {
      vivo = false;
    };
  }, []);
  const onChange = (v) => {
    setValue(v);
    localStorage.setItem("ida:sede", v);
    window.dispatchEvent(new CustomEvent("ida:sede", { detail: v }));
  };
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        data-testid="showroom-selector"
        aria-label="Sede"
        className={cn(
          suBlu
            ? "h-10 rounded-sm border-white/25 bg-transparent text-white hover:bg-white/10 focus:border-white focus:ring-white [&>svg]:text-white"
            : "h-10 min-w-[180px]",
        )}
      >
        <div className="flex min-w-0 items-center gap-2.5">
          <Store className={cn("size-[18px] shrink-0", suBlu ? "text-white" : "text-ink-2")} strokeWidth={1.75} aria-hidden="true" />
          <SelectValue placeholder="Seleziona sede" />
        </div>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all" data-testid="showroom-option-all">
          Tutte le sedi
        </SelectItem>
        {sedi.map((s) => (
          <SelectItem key={s.id} value={s.id} data-testid={`showroom-option-${s.codice}`}>
            {s.nome} · {s.provincia}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
